import { render, staticRenderFns } from "./reattribution-consultation.html?vue&type=template&id=1d5731e4&scoped=true&external"
import script from "./reattribution-consultation.js?vue&type=script&lang=js&external"
export * from "./reattribution-consultation.js?vue&type=script&lang=js&external"
import style0 from "./reattribution-consultation.scss?vue&type=style&index=0&id=1d5731e4&prod&scoped=true&lang=scss&external"
import style1 from "./index.vue?vue&type=style&index=1&id=1d5731e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5731e4",
  null
  
)

export default component.exports